/* eslint-disable react-hooks/exhaustive-deps */
import useClickUpload from "../../Hooks/useClickUpload";

import { useSelector, useDispatch } from "react-redux";
import SKRSelectors from "../../redux/selectors";
import SKRThunks from "../../redux/thunks";

import QuestionMark from "../../../../common/components/QuestionMark";
import { Button } from "antd";
import { PlusSquareTwoTone } from "@ant-design/icons";

import "./sk2r.scss";

const S2RContent = () => {
  // redux store selectors
  const user = useSelector((state) => state.session.authUser);
  const selectedSketch = useSelector(SKRSelectors.selectRecentSketchVersion); // sketch being disaplyed in left big box
  const selectedRender = useSelector(SKRSelectors.selectRecentRenderVersion); // render being displayed in right big box
  const selectedEditImage = useSelector(SKRSelectors.selectedImage); // image that is being edited
  const shaderType = useSelector(SKRSelectors.selectedShader); // type of shader to be sent to api
  const isLoading = useSelector((state) => state.s2r.status === "loading"); // render is loading

  // Hooks
  const dispatch = useDispatch();
  const [openFileSelector] = useClickUpload(); //custom hook to handle file upload

  async function renderSketch(sketch) {
    const base64Response = await fetch(sketch.src);
    const blob = await base64Response.blob();
    const formData = new FormData();
    formData.append("file", blob, "image.jpg");
    const req = {
      uuid: user.uid,
      formData,
    };
    // switch case to handle different types of shaders
    switch (shaderType) {
      case "classic":
        await dispatch(SKRThunks.renderClassic(req));
        break;
      case "onyx":
        await dispatch(SKRThunks.renderOnyx(req));
        break;
      default:
    }
  }

  return (
    <>
      <div
        style={{
          padding: "5%",
          height: "92vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            height: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            border: "1px solid #2C2C2C",
            margin: "0",
            padding: "0",
          }}
        >
          {selectedSketch && (
            <img
              style={{ maxWidth: "100%", maxHeight: "38rem" }}
              alt="main"
              src={selectedSketch?.src}
              className={
                selectedSketch?.id === selectedEditImage?.id ? "active" : ""
              }
            ></img>
          )}
        </div>
        <div className="skr-button-row">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PlusSquareTwoTone
              className="skr-plus-svg"
              twoToneColor="#447ce9"
              onClick={() => {
                openFileSelector();
              }}
            />
            <p style={{ color: "#FAF9F6", fontSize: ".75rem" }}>Add Images</p>
          </div>
          <div style={{ paddingRight: "1.5rem" }}>
            <Button
              style={{
                backgroundColor: "#447CE9",
                border: "none",
              }}
              type="primary"
              size="large"
              onClick={() => renderSketch(selectedSketch)}
              loading={isLoading}
              disabled={!selectedSketch || isLoading}
            >
              Render
            </Button>
          </div>
        </div>

        {/* Renders */}
        <div
          style={{
            height: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            border: "1px solid #2C2C2C",
            margin: "0",
            padding: "0",
          }}
        >
          {selectedRender && (
            <img
              alt="placeholder"
              src={selectedRender.src}
              style={{ maxWidth: "100%", maxHeight: "38rem" }}
              className={
                selectedRender?.id === selectedEditImage?.id ? "active" : ""
              }
            />
          )}
        </div>
      </div>
      <QuestionMark />
    </>
  );
};

export default S2RContent;
